// @ts-check
/**
 * Typed client for the engagements API.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').operations} Operations */
/** @typedef {Operations['api_engagements_clear_transcript_create']['parameters']['path']['id']} EngagementId */

/**
 * POST /api/engagements/{id}/clear_transcript/ — clear transcript, summary, and parsed content.
 * @param {EngagementId} id
 * @returns {Promise<void>}
 */
export async function clearTranscript(id) {
  await axios.post(`/api/engagements/${id}/clear_transcript/`)
}
